import Vue from 'vue'
import es6Promise from 'es6-promise'
es6Promise.polyfill() // Check Browser compatibility and make them equal
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import NProgress from 'vue-nprogress'
import VueCookie from 'vue-cookie'
import { sync } from 'vuex-router-sync'
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filters'
// import { TOGGLE_SIDEBAR } from 'vuex-store/mutation-types'
import moment from 'moment'
import * as globalConstants from './globalConstants'
import VuejsDialog from 'vuejs-dialog'
import VueNoty from 'vuejs-noty'

Vue.use(VueCookie)
Vue.use(VuejsDialog)

Vue.use(VueNoty, {
  theme: 'metroui',
  timeout: 3000,
  closeWith: ['click'],
  progressBar: false,
  layout: 'topCenter'
})

Vue.directive('focus', {
  inserted: function (el) {
    var onMobile = window.innerWidth < 767
    if (!onMobile) {
      el.focus()
    }
  },
  update: function (el) {
    Vue.nextTick(function () {
      var onMobile = window.innerWidth < 767
      if (!onMobile) {
        el.focus()
      }
    })
  }
})

Vue.router = router
Vue.use(VueAxios, axios)
Vue.use(VueAuth, {
  auth: {
    request: function (req, token) {
      this.options.http._setHeaders.call(this, req, {Authorization: 'Bearer ' + token})
    },
    response: function (res) {
      var token = res.data.token
      if (token) {
        return token
      }
    }
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: { url: globalConstants.apiURL + '/auth/local', fetchUser: false },
  fetchData: {url: globalConstants.apiURL + '/auth/local', method: 'GET', enabled: true},
  refreshData: { enabled: false },
  tokenStore: ['localStorage', 'cookie'],
  rolesVar: 'role'
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('MM-DD-YYYY')
  }
})

Vue.filter('formatDate2', function (value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
})

Vue.use(NProgress)

// Enable devtools
Vue.config.devtools = true

sync(store, router)

const nprogress = new NProgress({ parent: '.nprogress-container' })

// const { state } = store

router.beforeEach((route, redirect, next) => {
  setTimeout(() => {
    window.scrollTo(0, 0)
  }, 100)
  let user = window.localStorage.getItem('user')
  if (route.path === '/admin') {
    if (user) {
      user = JSON.parse(user)
      if (user.role === 'superAdmin') {
        next()
      } else {
        next({path: '/home'})
      }
    }
  } else if (route.path.indexOf('/onBoardMember') !== -1) {
    next()
  } else if (route.path === '/onBoard') {
    next()
  } else {
    if (route.path.indexOf('/login') !== -1 || route.path.indexOf('/resetPassword') !== -1 ||
    route.path.indexOf('/forgotPassword') !== -1 || route.path.indexOf('/requestDemo') !== -1 ||
    route.path.indexOf('/terms') !== -1) {
      next()
    } else {
      if (!user) {
        next({path: '/onBoard'})
      } else {
        next()
      }
    }
  }
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

const app = new Vue({
  router,
  store,
  nprogress,
  ...App
})

export { app, router, store }



// WEBPACK FOOTER //
// ./client/app.js